export const UPDATE_ALUNOS = 'UDPATE_ALUNOS'
export const ADD_ALUNOS = 'ADD_ALUNOS'
export const SET_ALUNOS = 'SET_ALUNOS'
export const REMOVE_ALUNOS = 'REMOVE_ALUNOS'
export const SET_ALUNO = 'SET_ALUNO'
export const SET_ALUNO_NULL = 'SET_ALUNO_NULL'
export const OPEN = 'OPEN'
export const CLOSE = 'CLOSE'
